import * as moment from 'moment';
import { Validator } from '../Validator';

export default class BirthDateService implements Validator {

  // tslint:disable-next-line no-any
  public getValidation(birthDate: any, message: string = 'birthDate'): Promise<void> {
    return new Promise(
      (res, error) => {
        if ((birthDate) && (moment().utc().diff(birthDate, 'years') > 17)) {
          res();
        } else {
          error(message);
        }
      });
  }
}


// WEBPACK FOOTER //
// ./src/services/validation/validators/BirthDate.tsx